var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-menu',[_c('v-btn',{attrs:{"text":"","color":"primary"}},[_c('span',[_vm._v("Повышение квалификации")]),_c('v-icon',{attrs:{"right":""}},[_vm._v("mdi-chevron-down")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }